import React from 'react';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import API from '../../configAPI';
import PulseLoader from 'react-spinners/PulseLoader';
import {Link} from 'react-router-dom';
import CONFIG from '../../config';
import Moment from 'react-moment';
import 'moment-timezone';
class PostList extends React.Component{
    constructor(props){
        super(props);
        this.state ={
            posts : {
                data: [],
                current_page: 1,
                total: 0,
                last_page: 1
            },
            loading: true
        }
    }
    componentDidMount(){
        this.getPosts();
    }
    getPosts =()=>{
        API.PRODUCTS(`posts?page=${this.state.posts.current_page}`)
        .then(resp =>{
            this.setState({
                posts : resp.data,
                loading : false
            });
        })
        .catch(err =>{
            console.log(err);
        });
    }
    onChanhePage = async(page) =>{
        await this.setState({
            posts : {
                ...this.state.posts,
                current_page : page
            },
            loading : !this.state.loading
        });

        this.getPosts();
    }
    render(){
        return (
            <div className="container-fluid mt-2 mb-3">
                <div className="col-12">
                    <PulseLoader
                        css={CONFIG.spinner_css}
                        size={CONFIG.spinner_size}
                        margin={CONFIG.spinner_margin}
                        color={CONFIG.spinner_color}
                        loading={this.state.loading}
                    />
                    <div className="row">
                        <section className="col-12">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                <li className="breadcrumb-item" aria-current="page"><span className="black">Todas las noticias</span></li>            
                                </ol>
                            </nav>
                        </section>
                    </div>
                    <div className="mt-3 d-flex justify-content-center">
                        {this.state.posts.last_page > 1 &&
                            <Pagination 
                                onChange={this.onChanhePage}
                                current={this.state.posts.current_page}
                                total={this.state.posts.total}
                                showTitle={false}
                                defaultPageSize={this.state.posts.to}
                            />
                        }
                    </div>
                    <div className="row">
                        {this.state.posts.data.map((post,index) =>(
                            <section className="col-xs-12 col-md-4 mt-1 mb-1" key={index}>
                                <div className="fila relativo">
                                    <Link to={`/noticia/${post.slug}`}> 
                                        <img src={post.url_image} className="img-fluid" alt="Hola"/>
                                        <div className="noticialink d-flex align-items-center p-2">
                                            <div className="fila">
                                            <section className="col-12 text-center">
                                                <h2 className="noticiatitulo">{post.title}</h2>
                                            </section>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="mt-3">
                                    <h6><strong>{post.title}</strong></h6>
                                    <p className="minitext">Publicado el <Moment format={'DD/MM/YYYY'}>{post.created_at}</Moment></p>
                                    <p>{post.description.substr(0,70)} ...</p>
                                </div>
                            
                            </section>
                        ))}
                    </div>
                    <div className="mt-3 d-flex justify-content-center">
                        {this.state.posts.last_page > 1 &&
                            <Pagination 
                                onChange={this.onChanhePage}
                                current={this.state.posts.current_page}
                                total={this.state.posts.total}
                                showTitle={false}
                                defaultPageSize={this.state.posts.to}
                            />
                        }
                    </div>
                </div>

            </div>
        )
    }
}

export default PostList;